import { Observable, OperatorFunction } from "rxjs";
import { NgZone } from "@angular/core";
import { inZone } from "./fn/in-zone-fn";

export function runInZone<T>(zone: NgZone): OperatorFunction<T, T> {
  return (source) => {
    return new Observable((observer) => {
      const onNext = (value: T) => inZone(zone, () => observer.next(value));
      const onError = (e: any) => inZone(zone, () => observer.error(e));
      const onComplete = () => inZone(zone, () => observer.complete());
      return source.subscribe({ next: onNext, error: onError, complete: onComplete });
    });
  };
}
